import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import ContentContainer from "../components/ContainerComponents/ContentContainer";
import MainContainer from "../components/ContainerComponents/MainContainer";
import HeaderContainer from "../components/ContainerComponents/HeaderContainer";
import When from "../components/When";
import {useAppSelector} from "../store/hooks";

const Support = () => {
    const user = useAppSelector((state) => state.user);
    return <MainContainer>
        <HeaderContainer title="Support"/>
        <ContentContainer style={{minHeight: "400px"}}>
            <Row className="mb-2">
                <Col>
                    <strong>Om du har några frågor kontakta vår support.</strong>
                </Col>
            </Row>
            <When condition={user && user.authenticated} otherwise={
                <Row className="mb-2">
                    <Col><a href="mailto:Support@ccicon.se">Support@ccicon.se</a></Col>
                </Row>
            }>
                <Row className="mb-3">
                    <Col>
                        <strong>Öppet vardagar 8-12.</strong>
                    </Col>
                </Row>
                <Row className="mb-2">
                    <Col>033-140600</Col>
                </Row>
                <Row>
                    <Col><a href="mailto:Support@ccicon.se">Support@ccicon.se</a></Col>
                </Row>
            </When>
        </ContentContainer>
    </MainContainer>
}

export default Support;